export enum EChatStoreKey {
    OpenedChat = 'openedChatSK',
}
